import { apiAppSettingsFeaturesAnalyticclick } from '#lib/types/generated/index.js';
import { get, writable } from 'svelte/store';
import { adminStore } from './admin';

type WishFeature = {
	feature: string;
	vote: boolean | null;
};

type FeatureClicked = {
	feature: string;
	clicks: number;
};

export const wishListFeatureStore = writable<WishFeature[]>([]);

export const featuresClicked = writable<FeatureClicked[]>([]);

export function clickFeature(feature: string) {
	if (!get(adminStore)) {
		apiAppSettingsFeaturesAnalyticclick({
			feature
		});

		const existingFeature = get(featuresClicked).find((f) => f.feature === feature);
		featuresClicked.update((fs) =>
			fs
				.filter((f) => f.feature !== feature)
				.concat({
					feature: feature,
					clicks: existingFeature ? existingFeature.clicks + 1 : 1
				})
		);
	}
}
